"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var SortableHeaderFormatter_1 = require("../datagrid/headerFormatters/SortableHeaderFormatter");
var SelectionColumn_1 = require("../datagrid/sharedColumns/SelectionColumn");
var TypedDataGridInterfaces_1 = require("../datagrid/TypedDataGridInterfaces");
var ExplorerStyledDisplayGrid_1 = require("./ExplorerStyledDisplayGrid");
var columns = [
    function () { return SelectionColumn_1.createSelectionColumn(); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.TableauUserOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: LinkCellFormatter_1.createLinkCellFormatter(function (_a) {
            var name = _a.name, username = _a.username;
            return name || username;
        }, function (urls, _a) {
            var username = _a.username, domain = _a.domain;
            return urls.userPath(username, domain);
        }),
        resizable: true,
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'ownedWorkbooks',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderOwnedWorkbooks(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var workbookCount = _a.workbookCount;
            return workbookCount;
        }),
        resizable: true,
        sortable: false,
    }); },
    function (sortParams) { return ({
        name: 'ownedDatasources',
        dataKey: TypedDataGridInterfaces_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderOwnedDatasources(),
        headerFormatter: SortableHeaderFormatter_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var datasourceCount = _a.datasourceCount;
            return datasourceCount;
        }),
        resizable: true,
        sortable: false,
    }); },
];
function OwnersDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: GraphQLErrorFunctions_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.OwnersDisplayGrid = OwnersDisplayGrid;
//# sourceMappingURL=OwnersDisplayGrid.js.map